import React, { useState } from "react";

import { Button, Modal } from "react-bootstrap";

import styles from "./Home.module.scss";

export const ACKNOWLEDGEMENT_OF_COUNTRY_MODAL = { key: "hasSeenAcknowledgementOfCountryModal", value: "true" };

const AcknowledgementOfCountryModal = () => {
  const [show, setShow] = useState(localStorage.getItem(ACKNOWLEDGEMENT_OF_COUNTRY_MODAL.key) !== "true");

  const onCloseAcknowledgementOfCountryModal = () => {
    setShow(false);
    localStorage.setItem(ACKNOWLEDGEMENT_OF_COUNTRY_MODAL.key, ACKNOWLEDGEMENT_OF_COUNTRY_MODAL.value);
  };
  return (
    <Modal
      show={show}
      onHide={() => onCloseAcknowledgementOfCountryModal()}
      size="xl"
      centered
      contentClassName={styles["modal-container"]}
    >
      <Modal.Header className="p-0">
        <div className="h3 mb-0 text-center w-100">Acknowledgment of Country</div>
      </Modal.Header>
      <Modal.Body className="px-0 py-5">
        <div className="b1 text-center">
          <p>
            We acknowledge the Traditional Custodians on whose land our office stands: the Gadigal of the Eora nation.
            We value their heritage, beliefs and relationship with the land, which are often expressed through art.
          </p>
          <p>We pay our respects to their Elders past and present.</p>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-top-0 p-0 justify-content-center">
        <Button variant="primary" onClick={() => onCloseAcknowledgementOfCountryModal()} size="lg">
          <div className="h5 mb-0 bold">Close</div>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AcknowledgementOfCountryModal;
